import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import DropFileUploader from '../../components/form/DropFileUploader';
import FormField from '../../components/form/FormField';
import ReduxFormPackSelect from '../../components/reduxFormMUIWrapper/ReduxFormPackSelect';

const useStyles = makeStyles({
  root: {
    composes: 'flexColumn stretch',
  },
});

let BackgroundForm = (props) => {
  const { handleSubmit } = props;
  const classes = useStyles(props);

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <FormField label="Pack" name="pack" component={ReduxFormPackSelect} fullWidth />
      <FormField label="Titre" name="title" fullWidth />
      <FormField label="Description" name="description" fullWidth />
      <FormField label="Image" name="image" component={DropFileUploader} fullWidth />
      <input type="submit" />
    </form>
  );
};

BackgroundForm.propTypes = {
  onSubmit: PropTypes.func,
};

BackgroundForm = reduxForm({
  form: 'backgroundForm',
  enableReinitialize: true,
})(BackgroundForm);

// Edition: the background loaded by editBackground. Creation: the `initialValues` prop (the pack preselected).
BackgroundForm = connect((state, ownProps) => {
  if (ownProps.initialValues) return {};
  const { pack, title, description, image } = state.backgrounds.background || {};
  return {
    initialValues: { pack: pack?.objectId ?? '', title, description, image },
  };
})(BackgroundForm);

export default BackgroundForm;
